import documentLocation from 'honeycomb-web-toolkit/src/document/js/honeycomb.document.location';

const init = () => {
    doSearchBasedOnUri();
};

const doSearchBasedOnUri = () => {
    const query = documentLocation.getUrlParameterByName('s');
    if (query) {

        // We're on the search results page.
        const form = document.querySelector('.gsc-search-box');

        if (form) {
            const input = document.querySelector('input.gsc-input');
            const button = document.querySelector('.gsc-search-button');

            if (input) {
                input.focus();
                input.value = query;
            }
            if (button) {
                button.click();
            }
        }
    }
};

export default {
    init
};
